import { render, staticRenderFns } from "./CategoryAttributeSelect.vue?vue&type=template&id=b4a31af8&scoped=true&"
import script from "./CategoryAttributeSelect.vue?vue&type=script&lang=js&"
export * from "./CategoryAttributeSelect.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAttributeSelect.vue?vue&type=style&index=0&id=b4a31af8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a31af8",
  null
  
)

export default component.exports